class RecordNotFoundError extends Error {
  constructor(msg) {
    super(msg);
    this.recordNotFound = true;
  }
}

class InvalidationError extends Error {}

// Checks the code in the response body.
// Expects shape like { code: 422, data: null, messages:[{ "field": "x", "text": "invalid" }] }
export default function checkResponseBodyCode({ code, data, message }) {
  switch (code) {
    case 200:
      return data || true;
    case 204:
      throw new RecordNotFoundError(message);
    case 422:
      throw new InvalidationError(message);
    default:
      throw new Error(message);
  }
}
